import { render, staticRenderFns } from "./courseSelectionWtxh.vue?vue&type=template&id=b2545196&scoped=true"
import script from "./courseSelectionWtxh.vue?vue&type=script&lang=js"
export * from "./courseSelectionWtxh.vue?vue&type=script&lang=js"
import style0 from "./courseSelectionWtxh.vue?vue&type=style&index=0&id=b2545196&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2545196",
  null
  
)

export default component.exports